const skrillPaymentMethodCodes: { [key: string]: string } = {
	MONEYBOOKERS_1TAP: 'MONEYBOOKERS_1TAP',
	MONEYBOOKERS: 'MONEYBOOKERS'
};

const isSkrillMethod = (methodCode: string): boolean => {
	return !!skrillPaymentMethodCodes[methodCode];
};

const FormTemplateEnum = {
	CREDIT_CARD: ['CREDIT-CARD', 'DIRECTLY-ROUTED-CREDIT-CARD', 'ASTROPAY-CREDIT-CARD'],
	PAY_BLIK: ['DOTPAY-BLIK', 'TPAY-BLIK'],
	TSI_VOUCHER: ['TSI', 'VOUCHER'],
	NO_FIELDS: ['SWISH', 'JPAY_DEPOSIT', 'FOGHORN_DEPOSIT', 'CRYPTO_DEPOSIT', 'BANK_WIRE_INDIA', 'BANK_WIRE_INDIA_UPI']
};

export const getTemplateCode = (methodCode: string, formTemplateCode: string): string => {
	switch (true) {
		case FormTemplateEnum.CREDIT_CARD.includes(formTemplateCode):
			return 'CRED-CARD';

		case FormTemplateEnum.PAY_BLIK.includes(formTemplateCode):
			return 'PAY-BLIK';

		case FormTemplateEnum.TSI_VOUCHER.includes(formTemplateCode):
			return 'TSI-VOUCHER';

		case FormTemplateEnum.NO_FIELDS.includes(formTemplateCode):
			return 'NO-FIELDS';

		case formTemplateCode === 'EMAIL' && isSkrillMethod(methodCode):
			return 'EMAIL_MONEYBOOKERS';

		default:
			return formTemplateCode;
	}
};

export const noDataFormCodes = [
	'DOTPAY-BLIK',
	'TPAY-BLIK',
	'NO-FIELDS',
	'JPAY_DEPOSIT',
	'FOGHORN_DEPOSIT',
	'CRYPTO_DEPOSIT',
	'BANK_WIRE_INDIA',
	'BANK_WIRE_INDIA_UPI',
	'VIRTUAL-CREDIT-CARD',
	'PEER-TO-PEER',
	'SWISH',
	'EMP_CASHLIB',
	'IMOJE_BANK',
	'PHONE'
];

export const SKIP_AMOUNT_SUGGESTION_KEY = 'SKIP_AMOUNT_SUGGESTION';
